import { auth } from "./firebase";
import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    sendPasswordResetEmail,
    updatePassword,
    sendEmailVerification,
    signOut,
    confirmPasswordReset,
    updateProfile,
    deleteUser
} from "firebase/auth";

// Crear usuario con correo y contraseña
export const doCreateUserWithEmailAndPassword = async (email, password, name, cuit, empresa, rol) => {
    try {
        // Crear el usuario en Firebase Auth
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;

        // Actualizar el perfil del usuario con el nombre y rol
        await updateProfile(user, {
            displayName: name,
            photoURL: rol, 
        });

        return user;
    } catch (error) {
        console.error("Error al crear el usuario:", error);
        throw error;
    }
};


// Iniciar sesión con correo y contraseña
export const doSignInWithEmailAndPassword = async (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
};

// Enviar solicitud de restablecimiento de contraseña
export const doPasswordReset = async (email) => {
    return sendPasswordResetEmail(auth, email)
};

export const confirmReset = async (oobCode, newPassword) => {
    return confirmPasswordReset(auth, oobCode, newPassword);
}

// Actualizar la contraseña del usuario
export const doPasswordUpdate = async (password) => {
    return updatePassword(auth.currentUser, password);
};

// Enviar verificación de email al usuario
export const doSendEmailVerification = async () => {
    return sendEmailVerification(auth.currentUser, {
        url: `${window.location.origin}/home`, // URL a la que redirigir después de la verificación
    });
};

// Cerrar sesión
export const doSignOut = async () => {
    localStorage.removeItem("cart"); 
    return signOut(auth);
};

// Eliminar usuario actual de Firebase Auth
export const doDeleteCurrentUser = async () => {
    if (!auth.currentUser) {
        throw new Error("No hay usuario autenticado para eliminar");
    }
    return deleteUser(auth.currentUser);
};

// Registro transaccional seguro con rollback automático
export const doCreateUserWithRollback = async (email, password, name, cuit, empresa, rol, createUserCallback) => {
    let firebaseUser = null;
    
    try {
        // Paso 1: Crear usuario en Firebase Auth
        console.log("🔄 Creando usuario en Firebase Auth...");
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        firebaseUser = userCredential.user;

        // Paso 2: Actualizar perfil en Firebase
        console.log("🔄 Actualizando perfil en Firebase...");
        await updateProfile(firebaseUser, {
            displayName: name,
            photoURL: rol, 
        });

        // Paso 3: Crear usuario en nuestra base de datos
        console.log("🔄 Creando usuario en base de datos...");
        const dbResult = await createUserCallback(firebaseUser.uid, name, email, cuit, empresa, rol);
        
        console.log("✅ Usuario creado exitosamente en ambos sistemas");
        return { firebaseUser, dbResult };
        
    } catch (error) {
        console.error("❌ Error durante el registro:", error);
        
        // ROLLBACK: Si hay error y se creó el usuario en Firebase, lo eliminamos
        if (firebaseUser) {
            try {
                console.log("🔄 Ejecutando rollback: eliminando usuario de Firebase Auth...");
                await deleteUser(firebaseUser);
                console.log("✅ Rollback completado: usuario eliminado de Firebase Auth");
            } catch (rollbackError) {
                console.error("❌ Error crítico en rollback:", rollbackError);
                // En este caso, el usuario quedará huérfano, pero al menos lo registramos
                throw new Error(`Error en registro Y rollback fallido. Usuario huérfano creado en Firebase con UID: ${firebaseUser.uid}. Error original: ${error.message}. Error rollback: ${rollbackError.message}`);
            }
        }
        
        // Re-lanzar el error original
        throw error;
    }
};
